// src/components/LoginForm.jsx
import { useState } from "react";
import { TextField, Button, Box, Typography, Stack } from "@mui/material";
import { login } from "../api/authService";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "../context/SnackbarContext";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { resendPassword } from "../api/authService";

const LoginForm = () => {
    const { t } = useTranslation('common');
    const { handleLogin } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { showSnackbar } = useSnackbar();

    const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim()) {
            showSnackbar(t('messages.email_required'), "warning");
            return;
        }
        if (!password.trim()) {
            showSnackbar(t('messages.password_required'), "warning");
            return;
        }
        try {
            const res = await login(email, password); // res contains token + refreshToken
            handleLogin(res.token);                   // update role + auth state
            navigate("/dashboard");
        } catch (err) {
            console.log(err);
            if (err.status === 403)
            {
                showSnackbar(t('messages.account_disabled'), "error");
            } 
            else {
                showSnackbar(t('messages.login_fail'), "error");
            }
        }
    };

    const handleResendPassword = async (email) => {
        try {
          const res = await resendPassword(email); 
          showSnackbar(res.message, "success");
        } catch (err) {
          showSnackbar(err.response.data.error, "error");
        }
    };

    return (
        <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ maxWidth: 400, mx: "auto", mt: 8 }}
        >
        <Typography variant="h5" mb={2}>Login</Typography>
        <Stack spacing={1}>
        <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
        />
        </Stack>

        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            {t('buttons.login')}
        </Button>
        <Button 
          variant="outlined" 
          fullWidth sx={{ mt: 2 }}
          onClick={() => setForgotPasswordOpen(true)}
        >
            {t('buttons.forgot_password')}
        </Button>
        <ForgotPasswordForm 
          callback={handleResendPassword}
          open={forgotPasswordOpen}
          onClose={() => setForgotPasswordOpen(false)}
        />
        </Box>
    );
};

export default LoginForm;
